import { inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { Settings } from './config/settings';

export const appConfigInitializer = () => {
    const proxy = inject(Settings);
    return proxy.load();
}

platformBrowser().bootstrapModule(AppModule,
    {
        applicationProviders: [
            provideZoneChangeDetection(),
            provideHttpClient(withXhr()),
            provideAppInitializer(appConfigInitializer)
        ]
    })
    .catch(err => console.error(err));
